<mat-dialog-content data-cy="no-ssin-dialog-content">
  <h2>{{ 'no-ssin-dialog.title' | translate }}</h2>
  <p>{{ 'no-ssin-dialog.message' | translate }}</p>
  <form [formGroup]="dialogDataForm">
    <div (drop)="onDropID($event)">
      <mat-form-field class="formfield-wrapper mb-3">
        <mat-label>{{ 'no-ssin-dialog.label' | translate }}</mat-label>
        <input formControlName="ssin" matInput appearance="fill" [showMaskTyped]="true" mask="00.00.00-000.00"
               data-cy="no-ssin-dialog-input"/>
        <mat-error data-cy="no-ssin-dialog-error">
          {{ 'no-ssin-dialog.error-message' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
  </form>
  <div class="info-container">
    <p> <mat-icon class="material-icons-outlined" fontIcon="info"/> </p>
    <p> {{ 'no-ssin-dialog.drag-and-drop' | translate }}</p>
  </div>

</mat-dialog-content>
<mat-dialog-actions data-cy="no-ssin-dialog-actions">
  <button (click)="onConfirm()" [disabled]="dialogDataForm.invalid"
          class="btn btn-primary">{{ 'no-ssin-dialog.confirm' | translate }}
  </button>
  <button mat-dialog-close
          class="btn btn-link">{{ ('no-ssin-dialog.' + (data.isLogout ? 'logout' : 'cancel')) | translate }}
  </button>
</mat-dialog-actions>
